/* eslint-disable */
import React from 'react';
import { TreeView } from '@material-ui/lab';
import { withStyles } from '@material-ui/styles';
import { styles } from './styles';
import { Props } from './types';
import ParentExpansion from '../../ParentExpansion';

export const Subcategory = withStyles(styles)(
  class Subcategory extends ParentExpansion<Props> {
    readonly subcategory: React.RefObject<HTMLDivElement>;

    constructor(props) {
      super(props);
      this.subcategory = React.createRef();
    }

    get titleRole() {
      return 'subcategory-title';
    }

    get bodyRole() {
      return 'subcategory-body';
    }

    get filtredChildren() {
      const children = (this.boundChildren || []) as any[];
      const childrenAsAray = React.Children.toArray(children);
      return childrenAsAray.filter(Boolean) as React.ReactElement[];
    }

    get mergedChildren() {
      const root = this.findChild(this.titleRole);
      const body = this.findChild(this.bodyRole);
      const items = body && body.props && body.props.children;
      return root && React.cloneElement(root, { items });
    }

    render() { 
      const { expanded } = this.state;
      const defaultExpanded = expanded ? ['root'] : [];
      return (
        <TreeView
          ref={this.subcategory} 
          // classes={classes}
          onNodeToggle={this.toggleExpand}
          defaultExpanded={defaultExpanded}
        >
          {this.mergedChildren}
        </TreeView>
      );
    }

    protected findChild = (role) => this.filtredChildren.find(x => {
      const props = (x as React.ReactElement)!.props as any;
      return props.role === role;
    });
  }
)

export default Subcategory;

export * from './SubcategoryBody';
export * from './SubcategoryTitle';